import {
  RETRIEVE_WITHDRAWLIST
} from "../actions/types";


const initialState = { withdraw: [], totalWithdrawCount: 0 };

const withdrawReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RETRIEVE_WITHDRAWLIST:
      return {
        ...state,
        withdraw: payload?.withdrawReqListInfo,
        totalWithdrawCount: payload.totalRecords,
      };


    default:
      return state;
  }
};

export default withdrawReducer;
